/**
 * Wrapper components for framer-motion that properly type className and ref props.
 *
 * In framer-motion 11.x, the types for motion.div don't include className by default.
 * This file provides typed wrappers that work correctly with React 19 / TypeScript 5.x.
 */
'use client';

import { motion, AnimatePresence, HTMLMotionProps } from 'framer-motion';
import { forwardRef, ComponentPropsWithoutRef } from 'react';

// Re-export AnimatePresence directly
export { AnimatePresence };

// Type that extends HTMLMotionProps with className and standard HTML attributes
type MotionDivProps = HTMLMotionProps<'div'> & ComponentPropsWithoutRef<'div'>;
type MotionSpanProps = HTMLMotionProps<'span'> & ComponentPropsWithoutRef<'span'>;
type MotionButtonProps = HTMLMotionProps<'button'> & ComponentPropsWithoutRef<'button'>;

// Create properly typed motion components
export const MotionDiv = forwardRef<HTMLDivElement, MotionDivProps>((props, ref) => (
  <motion.div {...props} ref={ref} />
));
MotionDiv.displayName = 'MotionDiv';

export const MotionSpan = forwardRef<HTMLSpanElement, MotionSpanProps>((props, ref) => (
  <motion.span {...props} ref={ref} />
));
MotionSpan.displayName = 'MotionSpan';

export const MotionButton = forwardRef<HTMLButtonElement, MotionButtonProps>((props, ref) => (
  <motion.button {...props} ref={ref} />
));
MotionButton.displayName = 'MotionButton';

// Re-export the original motion for cases where it works correctly
export { motion };
